import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '../../../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import CookieManager from '../../CookieManager';


const UserInputStat = ({ caption, users, roles, endpoint, handleSubmit, stored, fileName }) => {
  const userInputDefault = "";
  const [userInput, setInputValue] = useState(userInputDefault);
  const [error, setError] = useState(null);
  let isViewButtonVisible = false;

  let labelParameter = "";
  let placeholder = null;
  let placeholderError = null;
  if (
      stored === "SpStatsPricatFromMasterData"
      || stored === "SpStatsAllResultsSoldQty_GroupByBrandSizeModelSeason"
    ) {
    placeholder = "Vuoto oppure inserisci brand es. Michelin";
    labelParameter = "Brand";
    isViewButtonVisible = true;
  } else if (
      stored === "SpStatsStocksTrMn"
      || stored === "SpStatsTopRuoteNotInvoicedOrders") {
    placeholder = "Vuoto oppure inserisci cod nts";
    labelParameter = "ProductId";
    isViewButtonVisible = true;
  } else if (stored === "SpStatsDistributorRules") {
    placeholder = "Vuoto oppure inserisci il twoLettersCode";
    labelParameter = "distr2Lc";
    isViewButtonVisible = true;
  } else if (stored === "SpCustomersByDomain") {
    placeholder = "Inserisci il dominio es. cerchigomme.it";
    placeholderError = placeholder;
    labelParameter = "Dominio";
  } else if (stored === "SpStatsCountOrdersByDomain") {
    placeholder = "Inserisci i domini separati da ','";
    placeholderError = placeholder;
    labelParameter = "domainList";
    isViewButtonVisible = true;
  } else if (stored === "SpStatsNtsReconcileDDTInvoices") {
    placeholder = "Inserisci il numero della Fattura, es. 25/51/04506";
    placeholderError = placeholder;
    labelParameter = "docNumb";
    isViewButtonVisible = true;
  } else if (stored === "SpStatsTiresMonthlyReport_GroupBySize") {
    placeholder = "Inserisci brand, es. Michelin";
    placeholderError = placeholder;
    labelParameter = "Brand";
    isViewButtonVisible = true;
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (placeholderError && value.trim() === "") {
      setError(placeholderError);
      setInputValue(null);
    } else {
      setError(null);
      setInputValue(value);
    }
  };

  const doSubmit = (e, action) => {
    e.preventDefault();
    if (placeholderError && userInput.trim() === "") {
      setError(placeholderError);
    } else {
      let payload = { userInput: userInput, stored: stored, fileName: fileName };
      handleSubmit(e, endpoint, payload, action);
    }
  };

  if (CookieManager.isInUsers(users) || CookieManager.isInRoles(roles)) {
    return (
      <div className="container my-5">
        <div className="card p-3">
          <h5 className="card-title">{caption} </h5>
          <form>
            <div className="row align-items-end">
              <div className="col-md-4 mb-3">
                <label htmlFor="userInput" className="form-label">
                  {labelParameter}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="userInput"
                  value={userInput}
                  placeholder={placeholder}
                  onChange={handleInputChange}
                />
                {error && <div className="alert alert-danger">{error}</div>}
              </div>
              <div className="col-md-4 mb-3 offset-md-4 text-end">
                {isViewButtonVisible && <button type="button" className="btn btn-primary me-2" onClick={(e) => doSubmit(e, 'view')}>
                  <FontAwesomeIcon icon={faEye} />
                  View File
                </button>}
                <button type="button" className="btn btn-primary" onClick={(e) => doSubmit(e, 'download')}>
                  <FontAwesomeIcon icon="download" />
                  Download File
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default UserInputStat;